import { View } from 'react-native'

import { Placeholder, PlaceholderLine } from '@/src/elements/placeholder'
import { TEST_ID } from '@/src/general/constants/testId'

export const CommunitySearchPlaceholder = () => (
  <Placeholder className="my-2 flex h-80 flex-1 animate-fade px-0 py-0" testID={TEST_ID.COMMUNITIES.SEARCH_PLACEHOLDER}>
    <View className="flex-1">
      <PlaceholderLine className="min-h-32 flex-1 rounded-ee-none rounded-es-none" />
      <PlaceholderLine className="mx-4 mt-4 w-2/5" size="lg" />
      <PlaceholderLine className="mx-4 mt-4 w-1/5" size="lg" />
      <View className="flex-1 items-center justify-end pb-4">
        <PlaceholderLine className="mx-4 mt-2 w-[85%]" size="2xl" />
      </View>
    </View>
  </Placeholder>
)
